export const PaymentMethod = Object.freeze({
  MTN:    { value: 'cm.mtn',    label: 'MTN Mobile Money',    countryCodes: ['CMR'] },
  ORANGE: { value: 'cm.orange', label: 'Orange Money',         countryCodes: ['CMR'] },
  EUMM:   { value: 'cm.eumm',   label: 'Express Union Money',  countryCodes: ['CMR'] },
  YOOMEE: { value: 'cm.yoomee', label: 'Yoomee Money',         countryCodes: ['CMR'] },
})

// Liste à plat pour les <select> et boucles v-for
export const PAYMENT_METHODS = Object.values(PaymentMethod)

export function getPaymentMethodsForCountry({ countryIso = null, includeAll = false } = {}) {
  if (includeAll) return PAYMENT_METHODS

  const iso = countryIso?.toUpperCase?.() ?? null
  if (!iso) return []

  return PAYMENT_METHODS.filter(method => method.countryCodes?.includes(iso))
}
